module.exports = __webpack_public_path__ + "static/media/module1.13c9e40d.png";